import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Container Security`}</h3>
    <p>{`Container security is the process of implementing security tools and policies that will give you the assurance that everything in your container is running as intended.
This includes protecting the infrastructure, the software delivery chain, runtime, and everything in between.With this in mind, the process of securing containers is continuous.
It should be integrated into your development process, automated to remove the number of manual touch points, and extended into the maintenance and operation of the underlying infrastructure.
This means protecting your build pipeline container images and runtime host, platform, and application layers.
Implementing security as part of the continuous delivery life cycle means your business will mitigate risk and reduce vulnerabilities across an ever-growing attack surface.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "46.18055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABqUlEQVQoz41SW08aURA+v7cvvvWhiaZ9appUqEqtNCC0TQOCreCNhlRtNJS0SaPUC4FlWdYVwTZIvHDRPed8zjluKpGm6bf5MjPfzs7MzjlMSulKwBVCuNe9rgvytUZUvkKnM6zLq74L9/qPrqwigwcuBBbXczDsuo6FkNqenrbhOIegjzCIwkkbZvsC98Hkbabs9K7ks3BCHpi2jjnn2pqmKb/m8zomQQqVT0+qfCyTxSOdMwiW/d7A7EoV818cpLcaCC9bmEmZCKbv6E8YaLZ63gwS/wKLfbYxOW/oItMLFUyRr2JlJ5IGNagiohpuOFjK1RFfO6QBLIRJUzayaiGasRD4YMBudsDefqrheawE/1wZPqI/UcYLj0pThd9nbbzJ1PB6sYqZ9G3jlx8rCHhUf/H0XRGbO7/A6r+7sBqXqDWJjWGqdyrHcM51sVfeOtRqotQkQlOqRr65EgqVNhj+E90+x5PZfYyF9jQDyRKCqYpelS9ewsjENr4dtMDomoFzQeR/petyfRCtsx4eBX/i4XQBj8NUML4PX6yI0dCujh+M/6BDdXADBr+B1iTvhVMAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Container Securirty ",
        "title": "Security Aspects for Conatiner",
        "src": "/ibm-cloudnative-journey/static/c3bfbe4d58da96ddb760d729ac256941/3cbba/ContainerSecurity.png",
        "srcSet": ["/ibm-cloudnative-journey/static/c3bfbe4d58da96ddb760d729ac256941/7fc1e/ContainerSecurity.png 288w", "/ibm-cloudnative-journey/static/c3bfbe4d58da96ddb760d729ac256941/a5df1/ContainerSecurity.png 576w", "/ibm-cloudnative-journey/static/c3bfbe4d58da96ddb760d729ac256941/3cbba/ContainerSecurity.png 1152w", "/ibm-cloudnative-journey/static/c3bfbe4d58da96ddb760d729ac256941/0cf63/ContainerSecurity.png 1332w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2>{`Build`}</h2>
    <ul>
      <li parentName="ul">{`Source code`}</li>
      <li parentName="ul">{`Image Quality - Where is it coming from ?`}</li>
      <li parentName="ul">{`Image Quality - Who is it coming from ?`}</li>
      <li parentName="ul">{`Least Privileged user`}</li>
      <li parentName="ul">{`CI tools ( Jenkins / Tekton / etc)`}</li>
      <li parentName="ul">{`Scanning Tools`}</li>
      <li parentName="ul">{`Secrets Management`}</li>
      <li parentName="ul">{`Signed Images`}</li>
    </ul>
    <h2>{`Ship`}</h2>
    <ul>
      <li parentName="ul">{`Trusted Registries and Repos`}</li>
      <li parentName="ul">{`Signature Authenticating and Authorizing`}</li>
      <li parentName="ul">{`Image Scanning`}</li>
      <li parentName="ul">{`Policies`}</li>
      <li parentName="ul">{`Ongoing assessment and automated remediation`}</li>
      <li parentName="ul">{`Integrity Assurance`}</li>
    </ul>
    <h2>{`Run`}</h2>
    <ul>
      <li parentName="ul">{`Prevent deployment of images  with known vulnerabilities`}</li>
      <li parentName="ul">{`Prevent deployment of  containers that require root`}</li>
      <li parentName="ul">{`Validate image signatures`}</li>
      <li parentName="ul">{`Monitor for new vulnerabilities
= Alerting Monitoring Deployments`}</li>
      <li parentName="ul">{`Resource Management`}</li>
      <li parentName="ul">{`Network segmentation`}</li>
      <li parentName="ul">{`Fine-grain application controls`}</li>
    </ul>
    <p>{`Tools Explored ;`}</p>
    <ul>
      <li parentName="ul">{`IBM Vulnerabilty Advisor`}</li>
      <li parentName="ul">{`AquaSecure CSP`}</li>
      <li parentName="ul">{`Prisma™ Cloud`}</li>
      <li parentName="ul">{`Opensource Trivy`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      